import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';
import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import MessageBody from 'bdvp-common/src/components/MessageBody';

import {
    useLang,
    useMediaConfigSearch,
} from 'bdvp-common/src/hooks/config';

const Title = styled.h3`
    font-family: ${({ theme }) => theme.fonts.family.primary};
    color: ${({ theme }) => theme.primaryTextColor};
    font-size: 18px;
    margin: 16px 0 24px;
    line-height: 1;
`;

const defaultMessage = {
    title: '',
    body: '',
};

const Message = (props) => {

    const { type } = props;

    const config = useMediaConfigSearch();
    const lang = useLang();

    const message = config?.messages?.[type]?.[lang] || defaultMessage;

    return (
        <>
            <Title>{message.title}</Title>
            <MessageBody content={message.body} />
        </>
    );

};

Message.propTypes = {
    type: PropTypes.string.isRequired,
};

export default Message;
